"use client";
import React from "react";

const MobileBookNow = () => {
  const handleClick = () => {
    window.dispatchEvent(new Event("open-booking-popup"));
  };

  return (
    <>
      <button
        type="button"
        onClick={handleClick}
        className="mobile-booknow d-md-none"
        aria-label="Book Now"
      >
        Book Now
      </button>
      <style jsx>{`
        .mobile-booknow {
          position: fixed;
          left: 16px;
          bottom: 20px;
          z-index: 9998;
          background: #0b4878;
          color: #fff;
          border: none;
          border-radius: 999px;
          padding: 12px 22px;
          font-weight: 700;
          font-size: 15px;
          box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);
          letter-spacing: 0.3px;
        }
        .mobile-booknow:active {
          transform: scale(0.97);
        }
      `}</style>
    </>
  );
};

export default MobileBookNow;
